import React from 'react';
import { Link } from 'react-router-dom';
import { ALL_URL, isValidDate } from 'helpers/utils';
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import DateTime, { DateTimeNoTimezone } from 'components/presentation/DateTime';
import Label from 'components/general/Label';



export default function ComponentDays({ daysItems, page = 'schedule' }) {
    let params = useUrlFriendlyToParameters();
    let _daysItems = daysItems;
    const isScheduleAndAllDisciplines = () => {
        return page === 'schedule' && (!params["mirs_discipline"] || params["mirs_discipline"] === ALL_URL.ALL_DISC);
    }
    const postList = _daysItems?.competition_schedule ? (
        <>
            {_daysItems?.competition_schedule?.map(schDay => (<DayItem key={schDay.date} day={schDay} page={page} />))}
        </>
    ) : (
        <div>No data</div>
    )
    return (
        <ul className={"d-flex flex-wrap DayContainer"}>
            {!isScheduleAndAllDisciplines() && <DayItem day='All days' page={page} />}
            {postList}
        </ul>
    )
}



export function DayItem({ day, page = 'schedule' }) {
    let params = useUrlFriendlyToParameters();
    const getURL = useGetURL()
    //Copy object in order to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   (Change URL object)

    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    // set paramsURL["mirs_event"] to all-event when filtered by event , and select a day
    // if (isValidDate(day?.date) && paramsURL["mirs_event"] && paramsURL["mirs_event"] !== ALL_URL.ALL_EVENT) {
    //     paramsURL["mirs_event"] = ALL_URL.ALL_EVENT;
    // }

    const _date = paramsURL["mirs_date"] //Date from url 

    let date = "";
    if (isValidDate(day.date)) {
        date = day.date;
    }
    paramsURL["mirs_date"] = date //pasamos a la URL la nueva fecha del JSON 

    const url = getURL(paramsURL, page)

    if (date === "") {
        return (
            <li className={`DayBox  ${!isValidDate(_date) ? "active" : ""}`} valuedate={date}>
                <Link to={url}>
                    <div className={`text-center  DayBigFont`} >
                        <Label data="LabelAllDays" />
                    </div>
                </Link>
            </li >
        );
    }
    return (
        <>
            <li className={`DayBox  ${(_date === date) ? "active" : ""}`} valuedate={date}>
                <Link to={url} aria-current={(_date === date) ? "page" : null}>
                    <div className='d-flex flex-column'>
                        <span className={`text-center  DayBigFont`}>
                            <DateTimeNoTimezone format="DD" datetime={date} />
                        </span>
                        <span className={`text-center  DaySmallFont`}>
                            <DateTimeNoTimezone format="MMMM" datetime={date} />
                        </span>
                    </div>
                </Link>
            </li >
        </>
    )
}




